




















import { Vue, Component } from "vue-property-decorator"
import SHeader from "@/components/SHeader"
import { Getter } from "vuex-class"
import { HAS_USER_INFO } from "@/store/types/getters"

@Component({
    components: {
        SHeader,
    },
})
export default class App extends Vue {
    @Getter(HAS_USER_INFO) private hasUserInfo!: boolean
}
